const faqList = [
    {
        question: "colectivesLanding-colectivesLanding_faqQuestion1",
        answer: "colectivesLanding-colectivesLanding_faqAnswer1"
    },
    {
        question: "colectivesLanding-colectivesLanding_faqQuestion2",
        answer: "colectivesLanding-colectivesLanding_faqAnswer2"
    },
    {
        question: "colectivesLanding-colectivesLanding_faqQuestion3",
        answer: "colectivesLanding-colectivesLanding_faqAnswer3"
    },
    {
        question: "colectivesLanding-colectivesLanding_faqQuestion4",
        answer: "colectivesLanding-colectivesLanding_faqAnswer4"
    },
    {
        question: "colectivesLanding-colectivesLanding_faqQuestion5",
        answer: "colectivesLanding-colectivesLanding_faqAnswer5"
    },
    {
        question: "colectivesLanding-colectivesLanding_faqQuestion6",
        answer: "colectivesLanding-colectivesLanding_faqAnswer6"
    },
    {
        question: "colectivesLanding-colectivesLanding_faqQuestion7",
        answer: "colectivesLanding-colectivesLanding_faqAnswer7"
    },
]

module.exports = {
    faqList,
    COLLECTIVE_LANDING_CHANNEL: 'private',
    COLLECTIVE_LANDING_UI_COMPONENT: 1,
}
